import React from 'react';
import PropTypes from 'prop-types';
import GameArticleTitleStyled, {
  GameArticleTitleNumber,
  SVG,
} from './GameArticleTitle.styled';

const GameArticleTitle = ({ level, gameTheme }) => (
  <GameArticleTitleStyled>
    <SVG viewBox="-25 -5 130 150">
      <defs>
        <path id={`topHalfCircle-${level}`} d="M26,49 a15,9 0 0,1 28,0" />
      </defs>
      <title>Level {level}</title>
      <text dx="0 3 3 3 3 3">
        <textPath href={`#topHalfCircle-${level}`}>Level</textPath>
      </text>
    </SVG>
    <GameArticleTitleNumber gameTheme={gameTheme} title={`Level ${level}`}>
      {level}
    </GameArticleTitleNumber>
  </GameArticleTitleStyled>
);

export default GameArticleTitle;

GameArticleTitle.propTypes = {
  level: PropTypes.number.isRequired,
  gameTheme: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/GameArticleTitle/GameArticleTitle.js